module.exports = __webpack_public_path__ + "img/vi-bg-three.6ad11593.jpg";